<template>
  <div class="frisbuy-fashion-tile">
    <div ref="tileWrapper" class="frisbuy-fashion-tile__wrapper">
      <div
        v-if="titleMode === 'custom' && popupSettings?.header?.html"
        v-html="popupSettings.header.html"
        class="frisbuy-fashion-tile__title"
      ></div>
      <div
        v-else-if="titleMode !== 'hidden'"
        ref="tileTitle"
        class="frisbuy-fashion-tile__title"
      >
        <template v-if="titleMode === 'default'"> Готовые комплекты </template>
        <template v-if="titleMode === 'postsCount'">
          Посмотрите {{ productsList.length }}
          {{ getPluralizationForProductsTitle(productsList.length) }} из образа
        </template>
      </div>

      <div
        v-if="titleMode == 'default'"
        ref="tileSubtitle"
        class="frisbuy-fashion-tile__subtitle"
      >
        Наводите на товар и переходите в карточку товара
      </div>

      <div class="frisbuy-fashion-tile__kit" ref="tileKit">
        <ButtonArrow
          v-show="hasPrevPost"
          @click="() => makeEventToChangePost(-1)"
          :direction="'left'"
        />

        <div
          class="frisbuy-fashion-tile__main-item"
          v-touch:swipe="(direction: string) => changePostBySwipe(direction)"
        >
          <LikeButton
            :isLiked="isFullFavoriteLook"
            @click="() => addProductToFavoriteList(productsList, false)"
            :style="{
              'z-index': 4,
            }"
          />

          <slot name="imageArea"></slot>

          <div class="frisbuy-fashion-tile__price-info">
            <div class="frisbuy-fashion-tile__price">
              <span class="frisbuy-fashion-tile__price-title">
                Цена за комплект
              </span>
              <span class="frisbuy-fashion-tile__price-number">
                {{ getTotalPriceForAllProducts(productsList) }}
              </span>
            </div>

            <!-- NOTE: this button's layout is ready. But need to add functionality -->
            <button v-if="false" class="frisbuy-fashion-tile__add-to-cart">
              <svg
                width="16"
                height="21"
                viewBox="0 0 16 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.07812 6.45703H15.5V18.0742C15.5 18.5259 15.3205 18.9591 15.0011 19.2785C14.6817 19.5979 14.2485 19.7773 13.7968 19.7773H2.78125C2.32955 19.7773 1.89635 19.5979 1.57696 19.2785C1.25756 18.9591 1.07812 18.5259 1.07812 18.0742V6.45703Z"
                  stroke="white"
                />
                <path
                  d="M1.12891 6.50781H15.4492V18.0742C15.4492 18.5124 15.2751 18.9327 14.9652 19.2426C14.6554 19.5525 14.2351 19.7265 13.7969 19.7265H2.78125C2.34302 19.7265 1.92274 19.5525 1.61287 19.2426C1.30299 18.9327 1.12891 18.5124 1.12891 18.0742V6.50781Z"
                  stroke="white"
                />
                <path
                  d="M11.5938 8.71092V4.34103C11.5985 3.4598 11.253 2.61278 10.6332 1.98624C10.0135 1.3597 9.17034 1.00495 8.2891 1C7.40787 1.00495 6.56468 1.3597 5.94496 1.98624C5.32524 2.61278 4.97973 3.4598 4.98442 4.34103V8.71092"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="frisbuy-fashion-tile__add-to-cart-title">
                Добавить в корзину
              </div>
            </button>
          </div>
        </div>

        <div class="products-scoll-block">
          <div class="frisbuy-fashion-tile__kit-products">
            <ProductItem
              v-for="product in productsList"
              :key="product.id"
              :product="product"
              :linkTarget="
                Boolean(popupSettings.targetBlankLink) ? '_blank' : '_self'
              "
              :isLiked="
                Boolean(
                  favoriteVendorList.find((el) =>
                    isEqual(el, {
                      article: product.sku?.vendorCode,
                      offerId: product.sku?.offerId,
                      groupId: product.sku?.groupId,
                    })
                  )
                )
              "
              :pinColor="popupSettings.image.numberColor"
              :isShowPin="showUnpinnedNumbers"
              :popupText="popupText"
              @clickProduct="(product) => sendProductAnalytics(product)"
              @like="
                () => {
                  addProductToFavoriteList([product]);
                  mouseOver(product, false);
                }
              "
              @mouseenter="mouseOver(product, true)"
              @mouseleave="mouseOver(product, false)"
            />
          </div>
        </div>

        <ButtonArrow
          v-show="hasNextPost"
          @click="() => makeEventToChangePost(1)"
          :direction="'right'"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
/*
  NOTE: Don't use "scoped". It will break "media queries" style's block,
  because "scoped" has higher priority than not scoped
*/
@import "../mixins.scss";

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.frisbuy-fashion-tile {
  padding: 24px 0;

  .frisbuy-fashion-tile__wrapper {
    width: 100%;
    height: 100%;
    overflow: visible;

    padding: 0 72px 0 52px;
  }

  .frisbuy-fashion-tile__title {
    font-family: inherit;
    font-size: 32px;
    color: #2e353b;

    padding: 2.5px 0;
    margin-bottom: 16px;

    width: calc(100% - 44px); // 44px - width of Popup's close-button
  }

  .frisbuy-fashion-tile__subtitle {
    font-family: inherit;
    font-size: 16px;
    color: #2e353b;

    margin-bottom: 16px;
  }

  .frisbuy-fashion-tile__kit {
    container-type: inline-size;

    display: flex;
    position: relative;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 0 36px;

    width: 100%;

    .frisbuy-fashion-tile__main-item {
      position: relative;
      flex: 46.0222 0 0;

      .frisbuy-like-button {
        position: absolute;
        inset: 6px 6px auto auto;
        width: 30px;
      }

      .frisbuy-fashion-tile__price-info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        height: 40px;

        flex-wrap: wrap;
        gap: 10px 0;

        margin-top: 8px;

        .frisbuy-fashion-tile__price {
          display: flex;
          flex-direction: row;
          gap: 0 8px;

          & > * {
            display: inline-flex;
            align-items: center;
          }

          .frisbuy-fashion-tile__price-title {
            font-family: Inter, sans-serif;
            font-size: 12px;

            color: #525252;
          }

          .frisbuy-fashion-tile__price-number {
            font-family: Inter, sans-serif;
            font-size: 14px;

            color: #8f1837;
          }
        }

        .frisbuy-fashion-tile__add-to-cart {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          gap: 0 11px;

          width: 186px;
          height: 100%;

          border: none;
          background-color: #000000;

          svg {
            width: 15px;
            height: 19px;
          }

          .frisbuy-fashion-tile__add-to-cart-title {
            font-family: Inter, sans-serif;
            font-size: 13px;

            color: #ffffff;
          }
        }
      }
    }

    .products-scoll-block {
      flex: 53.9778 0 0;
      aspect-ratio: 950 / 728;
      height: 100%;
      overflow: auto;

      .frisbuy-fashion-tile__kit-products {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 16px;

        .frisbuy-product-item {          
          width: round(down, calc((1 / 3 * 100%) - (16px * 2 / 3)), 1px);; // 16px == gap
          height: auto;
        }
      }
    }

    .frisbuy-button-arrow {
      $arrowWidth: 43px;
      $marginFromContent: 8px;

      width: $arrowWidth;
      height: 100%;

      z-index: 3;

      padding: 0 14px;

      &.--left {
        left: calc(0cqmin - ($arrowWidth + $marginFromContent));
      }

      &.--right {
        right: calc(0cqmin - ($arrowWidth + $marginFromContent));
      }
    }
  }
}
</style>

<style lang="scss">
@import "../mixins.scss";
// media queries
.frisbuy-fashion-tile {
  container-type: inline-size;
  container-name: fashionTile;

  @container fashionTile (max-width: #{$size-m}) {
    @media screen and (orientation: landscape) {
      .frisbuy-fashion-tile__wrapper {
        padding: 0 60px 0 51px;

        .frisbuy-fashion-tile__kit {
          padding: 16px 0;

          .frisbuy-fashion-tile__main-item {
            flex: 40.076 0 0;
          }

          .products-scoll-block {
            flex: 59.924 0 0;
            aspect-ratio: 631 / 467;

            .frisbuy-product-item__image {
              aspect-ratio: 200 / 176.34;
            }
          }
        }
      }
    }

    @media screen and (orientation: portrait) {
      .frisbuy-fashion-tile__wrapper {
        $sidePadding: 16px;
        padding: 0 $sidePadding;

        .frisbuy-fashion-tile__kit {
          flex-direction: column;

          .products-scoll-block {
            aspect-ratio: unset;
            flex: unset;

            margin-top: 26px;

            .frisbuy-fashion-tile__kit-products {
              display: inline-flex;

              min-width: 100%;
              flex-wrap: nowrap;

              .frisbuy-product-item {
                width: 261px;
                height: fit-content;
              }
            }
          }

          .frisbuy-button-arrow {
            $arrowWidth: 43px;

            width: $arrowWidth;
            /*
              NOTE: be careful. "svw" equals default "vw"
              Chromium issue: https://issues.chromium.org/issues/372425128
            */
            height: calc(100svw - 2 * $sidePadding);

            z-index: 3;

            padding: 0 14px;

            top: 0;

            &.--left {
              left: 0cqmin;
              transform: scaleX(-1);
            }

            &.--right {
              right: 0cqmin;
              transform: unset;
            }
          }
        }
      }
    }
  }

  @container fashionTile (max-width: #{$size-xs}) {
    @media screen and (orientation: portrait) {
      .frisbuy-fashion-tile__wrapper {
        .frisbuy-fashion-tile__kit {
          .products-scoll-block {
            .frisbuy-fashion-tile__kit-products {
              .frisbuy-product-item {
                width: 198px;
              }
            }
          }
        }
      }
    }
  }

  @container fashionTile (max-width: #{$size-xxs}) {
    @media screen and (orientation: portrait) {
      .frisbuy-fashion-tile__wrapper {
        .frisbuy-fashion-tile__kit {
          .frisbuy-fashion-tile__main-item {
            .frisbuy-fashion-tile__price-info {
              & > * {
                width: 100%;
              }

              .frisbuy-fashion-tile__price {
                height: 23px;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<script lang="ts">
import { PropType, defineComponent } from "vue";
// @ts-ignore: lodash types's errors on build
import _ from "lodash";
import ProductItem from "./ProductItem.vue";
import LikeButton from "./LikeButton.vue";
import ButtonArrow from "./ButtonArrow.vue";
import {
  IFrisbuyWidgetPost,
  IPostLinkInList,
  IPostMedia,
} from "@/gallery/interfaces";
import { TProductCode } from "../interfaces";
import { getStock } from "@/common/mixins/analytics";

interface IFashionTile {
  favoriteVendorList: Array<TProductCode>;
}

export default defineComponent({
  inject: ["isTablet"],

  components: { ProductItem, LikeButton, ButtonArrow },

  emits: {
    changePostRequest: (direction: number) => {
      return direction;
    },
  },

  props: {
    fashion: {
      type: Object as PropType<IFrisbuyWidgetPost>,
      required: true,
    },

    titleMode: {
      type: String as PropType<"default" | "postsCount" | "custom" | "hidden">,
      required: false,
      default: "default",
    },

    // NOTE: this settings only for analytics in mixins
    // TODO: remove this after removing mixins
    settings: {
      type: Object,
      required: true,
    },

    popupSettings: {
      type: Object,
      required: true,
    },

    hasPrevPost: {
      type: Boolean,
      required: false,
      default: true,
    },

    hasNextPost: {
      type: Boolean,
      required: false,
      default: true,
    },

    popupText: {
      type: Object,
      required: true,
    },
  },

  data(): IFashionTile {
    return {
      favoriteVendorList: [],
    };
  },

  created() {
    this.initFrisbuyFavoriteList();
  },

  methods: {
    // TODO: refactor this shit
    isEqual(value: any, other: any) {
      return _.isEqual(value, other);
    },

    initFrisbuyFavoriteList() {
      if (window.frisbuyFavoriteList) {
        this.favoriteVendorList = window.frisbuyFavoriteList;
      }

      console.log("window.frisbuyFavoriteList", window.frisbuyFavoriteList);

      // TODO: refactor "defineProperty" logic. Too hard to understand
      let frisbuyFavoriteListWindowValue: Array<TProductCode> = [];

      Object.defineProperty(window, "frisbuyFavoriteList", {
        configurable: true,
        set: function (value) {
          if (!value) return;

          frisbuyFavoriteListWindowValue = value;

          console.log("defineProperties", value);
          this.favoriteVendorList = value || [];
        },

        get: function () {
          return frisbuyFavoriteListWindowValue;
        },
      });

      window.frisbuyFavoriteList = this.favoriteVendorList || [];
    },

    getPluralizationForProductsTitle(productsCount: number) {
      const lastNumber = Number(String(productsCount).slice(-1));

      if (lastNumber === 1) {
        return "товар";
      }

      if (lastNumber > 1 && lastNumber < 5) {
        return "товара";
      }

      if (lastNumber === 0 || lastNumber >= 5) {
        return "товаров";
      }
    },

    makeEventForClient(eventName: string, data: any) {
      document.dispatchEvent(new CustomEvent(eventName, data));
    },

    changePostBySwipe(direction: string) {
      if (direction === "left") {
        this.makeEventToChangePost(1);
      }

      if (direction === "right") {
        this.makeEventToChangePost(-1);
      }
    },

    makeEventToChangePost(direction: number) {
      this.$emit("changePostRequest", direction);
    },

    addProductToFavoriteList(
      products: Array<IPostLinkInList>,
      isRemoveExisting = true
    ) {
      const productCodes: Array<TProductCode> = products.map((product) => {
        return {
          article: product.sku?.vendorCode,
          offerId: product.sku?.offerId,
          groupId: product.sku?.groupId,
        };
      });

      if (!productCodes || !productCodes.length) {
        return;
      }

      let isAddingToFavorite = false;

      let listOfProducts: Array<TProductCode> = [];
      let isAllProductsSelected = false;
      let dubledProducts: Array<TProductCode> = [];

      listOfProducts.push(...productCodes);

      // NOTE: check on adding FullFavoriteLook
      if (productCodes.length > 1) {
        isAllProductsSelected = true;

        dubledProducts = listOfProducts.filter((propductFromList) => {
          const isIncludes = this.favoriteVendorList.find((el) => {
            return this.isEqual(el, propductFromList);
          });

          if (isIncludes) {
            return propductFromList;
          } else {
            isAllProductsSelected = false;
          }
        });
      }

      /*
        При добавлении всего образа клиент попросил отфильтровать уже выбранные, чтобы не удалять их со своей стороны
      */
      let listOfProductsWithoutDoublers = listOfProducts;

      console.log(listOfProducts.length, this.favoriteVendorList.length);
      if (listOfProducts.length !== this.favoriteVendorList.length) {
        console.log("filter");
        listOfProductsWithoutDoublers = listOfProducts.filter((product) => {
          const isIncludes = dubledProducts.find((el) => {
            return this.isEqual(el, product);
          });

          if (!isIncludes) {
            return product;
          }
        });
      }

      if (isAllProductsSelected) {
        this.removeCompilationOfCodesSafety(this.compilationOfAllProductsCodes);
      }

      if (!isAllProductsSelected) {
        listOfProducts.forEach((product) => {
          const existingElementIndex = this.favoriteVendorList.findIndex(
            (el) => {
              return this.isEqual(el, product);
            }
          );

          if (isRemoveExisting && existingElementIndex >= 0) {
            // Removing product from favorite
            this.favoriteVendorList.splice(existingElementIndex, 1);
          } else if (existingElementIndex === -1) {
            // Adding product to favorite
            this.favoriteVendorList.push(product);
            isAddingToFavorite = true;
          }
        });
      }

      if (isAddingToFavorite) {
        console.log(
          "%cfrisbuy:favorite-add detail",
          "background-color: #33ab55",
          listOfProductsWithoutDoublers
        );
        this.makeEventForClient("frisbuy:favorite-add", {
          detail: listOfProductsWithoutDoublers,
        });

        // [START] analytics
        const productsForAnalytics = products.filter((product) => {
          const originalProduct = listOfProductsWithoutDoublers.find(
            (productIds) => {
              const idsFromOriginalProduct: TProductCode = {
                article: product.sku?.vendorCode,
                offerId: product.sku?.offerId,
                groupId: product.sku?.groupId,
              };

              if (this.isEqual(idsFromOriginalProduct, productIds)) {
                return true;
              } else {
                return false;
              }
            }
          );

          return originalProduct;
        });

        // TODO: fix this after removing mixins
        // @ts-ignore: this analytics in fucking mixins
        this.sendAnaliticEvent("AddToFavorite", {
          provPostId:
            this.fashion.instagramPost?.frisbuyId ??
            this.fashion.providerPost.frisbuyId,
          fbProduct: this.fashion.frisbuyPost.id,
          igCode: this.fashion.instagramPost.shortcode,
          stock: getStock(
            this.postList,
            this.settings.embedId,
            this.settings.skuId
          ),

          items: productsForAnalytics,
        });
        // [END] analytics
      } else {
        console.log(
          "%cfrisbuy:favorite-remove detail",
          "background-color: #df3355",
          listOfProductsWithoutDoublers
        );
        this.makeEventForClient("frisbuy:favorite-remove", {
          detail: listOfProductsWithoutDoublers,
        });

        // [START] analytics
        // TODO: fix this after removing mixins
        // @ts-ignore: this analytics in fucking mixins
        // this.sendAnaliticEvent("RemoveFromFavorite", {
        //   provPostId:
        //     this.fashion.instagramPost?.frisbuyId ??
        //     this.fashion.providerPost.frisbuyId,
        //   fbProduct: this.fashion.frisbuyPost.id,
        //   igCode: this.fashion.instagramPost.shortcode,
        //   stock: getStock(
        //     this.postList,
        //     this.settings.embedId,
        //     this.settings.skuId
        //   ),

        //   items: productsForAnalytics,
        // });
        // [END] analytics
      }
    },

    removeCompilationOfCodesSafety(codesForRemoving: Array<TProductCode>) {
      const clearedFavoriteVendorList: Array<TProductCode> =
        this.favoriteVendorList.filter((favoriteCode) => {
          let isEqualCode = false;
          codesForRemoving.forEach((codeForRemoving) => {
            if (this.isEqual(codeForRemoving, favoriteCode)) {
              isEqualCode = true;
            }
          });

          if (!isEqualCode) {
            return favoriteCode;
          }
        });

      /* 
        NOTE:
          "this.favoriteVendorList = [];" or
          "this.favoriteVendorList = clearedFavoriteVendorList;" doesn't work
        In initFrisbuyFavoriteList defineProperties cannot see array's redefining
      */
      this.favoriteVendorList.splice(0, this.favoriteVendorList.length);
      this.favoriteVendorList.push(...clearedFavoriteVendorList);
    },

    sendProductAnalytics(product: IPostLinkInList) {
      // Сбрасываем hover состояние перед открытием ссылки
      this.mouseOver(product, false)

      // TODO: fix this after removing mixins
      // @ts-ignore: this analytics in fucking mixins
      this.sendAnaliticEvent("ClickLink", {
        provPostId:
          this.fashion.instagramPost?.frisbuyId ??
          this.fashion.providerPost.frisbuyId,
        fbProduct: this.fashion.frisbuyPost.id,
        igCode: this.fashion.instagramPost.shortcode,
        link: product.link,
        linklabel: product.title,
        offer: product.sku?.offerId,
      });
    },

    /*
      TODO: Rewrite the function.
      Function's parameters should not be changed
    */
    mouseOver(product: IPostLinkInList, state: boolean) {
      product.hover = state;
    },

    getTotalPriceForAllProducts(productsList: IPostLinkInList[]) {
      let fullPrice = 0;

      productsList.forEach((product) => {
        const price = product.sku?.price;
        if (!price) {
          return;
        }

        const priceAsNumber = Number(price.replaceAll(" ", ""));
        fullPrice += priceAsNumber;
      });

      const formattedFullPrice = new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB",
        minimumFractionDigits: 0,
        useGrouping: true,
      }).format(fullPrice);

      return formattedFullPrice;
    },
  },

  computed: {
    // NOTE: this settings only for analytics in mixins. Parameter "stock"
    // TODO: remove this after removing mixins
    postList(): Array<IFrisbuyWidgetPost> {
      const pseudoPostList = [this.fashion];
      return pseudoPostList;
    },

    productsList(): IPostLinkInList[] {
      return this.fashion.media[0].linkList;
    },

    isFullFavoriteLook(): boolean {
      const isFavorite =
        this.productsList.length > 0 &&
        !this.productsList.find((product) => {
          return !this.favoriteVendorList.find((favorit) => {
            const productCode: TProductCode = {
              article: product.sku?.vendorCode,
              offerId: product.sku?.offerId,
              groupId: product.sku?.groupId,
            };

            return this.isEqual(favorit, productCode);
          });
        });

      return isFavorite;
    },

    compilationOfAllProductsCodes(): Array<TProductCode> {
      const articlesList: Array<TProductCode> = this.productsList.map(
        (product) => {
          return {
            article: product.sku?.vendorCode,
            offerId: product.sku?.offerId,
            groupId: product.sku?.groupId,
          };
        }
      );

      console.log("articlesList", articlesList);

      return articlesList;
    },

    showUnpinnedNumbers(): boolean {
      return this.currentMedia.linkList.every(
        (link: IPostLinkInList) => link.marker.show
      );
    },
    currentMedia(): IPostMedia {
      return this.fashion && this.fashion.media[0];
    },
  },
});
</script>
